import React, { FC, memo, ReactNode, useEffect, useState } from 'react'
import s from './CardTwoBlock.module.sass'
import { Img } from '@shared/ui/Layout/CardTwoBlock/ui/Img'
import { Content } from '@shared/ui/Layout/CardTwoBlock/ui/Content'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { CardTwoBlockContext } from './Context'
import Link from 'next/link'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'

type size = 'L' | 'ML' | 'M' | 'S'

interface Props {
  children: ReactNode
  sizes: string
  href?: string
  className?: string
}

const CardTwoBlock = React.forwardRef<HTMLAnchorElement, Props>(
  ({ children, sizes = 'L ML', className = '', href, ...props }, ref) => {
    const [size] = useCurrentSize(sizes)

    const [context, setContext] = useState({
      href: href,
      size: size,
    })

    useEffect(() => {
      setContext((prev) => ({
        ...prev,
        size,
      }))
    }, [size])

    return (
      <ErrorBoundary>
        <CardTwoBlockContext.Provider value={[context, setContext]}>
          {/*@ts-ignore*/}
          <div className={`${s.card} ${className}`} data-size={size} {...props} ref={ref}>
            {children}
          </div>
        </CardTwoBlockContext.Provider>
      </ErrorBoundary>
    )
  },
)

CardTwoBlock.displayName = 'CardTwoBlock'
Img.displayName = 'CardTwoBlock.Img'
Content.displayName = 'CardTwoBlock.Content'

const CardTwoBlockNamespace = Object.assign(CardTwoBlock, { Img, Content })

export default CardTwoBlockNamespace
